/* Routing */
import {Link, useLocation} from "react-router-dom";


export default function AdminMenu({ user }) {
    const agencyPath = useLocation().pathname.slice(0, 14);
    const userPath = useLocation().pathname.slice(0, 19);
    const activityPath = useLocation().pathname.slice(0, 16);
    const emailPath = useLocation().pathname.slice(0, 13);
    const documentPath = useLocation().pathname.slice(0, 16);
    const productPath = useLocation().pathname.slice(0, 27);
    const networkPath = useLocation().pathname.slice(0, 15);
    const cmsPath = useLocation().pathname.slice(0, 10);
    const deceasedPath = useLocation().pathname.slice(0, 19);
    const billingPath = useLocation().pathname.slice(0, 20);
    const imagePath = useLocation().pathname.slice(0, 15);
    const OEF_VITRINE = process.env.REACT_APP_OEF_URL;
    const signout = (e) => {
        e.preventDefault();
        localStorage.removeItem("refresh_token");
        localStorage.setItem("persist", false);
        // logout
        window.location.href = "/pro/login";
    }
    return (
        <nav className="admin-nav">
            <ul>
                { user  && <li><span>{ user }</span></li> }
                <li><Link to="/admin/accueil"><i className="fa fa-home"></i>Accueil</Link></li>
                <li className={ agencyPath === "/admin/agences" && "active"}><Link to="/admin/agences">Agences</Link></li>
                <li className={ userPath === "/admin/utilisateurs" && "active"}><Link to="/admin/utilisateurs" >Utilisateurs</Link></li>
                <li className={ activityPath === "/admin/activites" && "active"}><Link to="/admin/activites" >Activités</Link></li>
                <li className={ emailPath === "/admin/emails" && "active"}><Link to="/admin/emails" >Emails</Link></li>
                <li className={ documentPath === "/admin/documents" && "active"}><Link to="/admin/documents" >Documents</Link></li>
                <li className={ productPath === "/admin/produits-facturables" && "active"}><Link to="/admin/produits-facturables" >Produits facturables</Link></li>
                <li className={ networkPath === "/admin/reseaux" && "active"}><Link to="/admin/reseaux" >Réseaux</Link></li>
                <li className={ deceasedPath === "/admin/defunts" && "active"}><Link to="/admin/defunts" >Défunts</Link></li>
                <li className={ cmsPath === "/admin/demarches" && "active"}><Link to="/admin/cms/demarches" >CMS</Link></li>
                <li className={ billingPath === "/admin/facturation" && "active"}><Link to="/admin/facturation" >Facturation</Link></li>
                <li className={ imagePath === "/admin/images" && "active"}><Link to="/admin/images/defunts" >Images</Link></li>
                <li onClick={signout}><a href="#"> | Déconnexion</a></li>
            </ul>
        </nav>
    )
}